import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useInvitationService } from "../../../hooks/useInvitationService";
import { activityQueryKeys } from "../constants";
import type { JoinRequestMeta } from "../types";

/** Denies a join request and invalidates activity queries. */
export function useDenyJoinRequestMutation(meta: JoinRequestMeta) {
    const invitationService = useInvitationService();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () =>
            invitationService.respondToWorkspaceJoinRequest(
                meta.workspaceId,
                meta.requestId,
                undefined,
                "decline"
            ),
        onSettled: () => queryClient.invalidateQueries({ queryKey: activityQueryKeys.all })
    });
}
